var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.main_sim_state).length > 0)?_c('div',{staticClass:"state"},[_c('span',{staticClass:"sphere mdi mdi-check-circle-outline",style:('background-color:' + _vm.main_sim_state.color)}),(Number(_vm.sim_state.temp) >= _vm.min_temp)?_c('span',{staticClass:"temp mdi mdi-thermometer",class:{
        temp_yellow: Number(_vm.sim_state.temp) >= _vm.min_temp && Number(_vm.sim_state.temp) < _vm.max_temp,
        temp_red: Number(_vm.sim_state.temp) >= _vm.max_temp
      }}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }